import MapTool from "@mapmycustomers/shared/enum/map/MapTool";
import { MapEntity } from "@mapmycustomers/shared/types/entity";
import {
  CategorizedMapEntries,
  EntityPin,
  MapEntitiesSet,
  MultiPin,
} from "@mapmycustomers/shared/types/map";
import RangeModel from "@mapmycustomers/shared/types/viewModel/internalModel/RangeModel";
import SortModel from "@mapmycustomers/shared/types/viewModel/internalModel/SortModel";
import MapViewState from "@mapmycustomers/shared/types/viewModel/MapViewState";

import GeoPointSortType from "@app/component/RecordList/components/CustomizeMapSortModal/enum/GeoPointSortType";
import { AreaSearchQuery } from "@app/types/filters/AreaSearchQuery";
import GeoPath from "@app/types/GeoPath";
import MapViewportState from "@app/types/map/MapViewportState";
import RulerPath from "@app/types/map/RulerPath";
import createDefaultMapViewState from "@app/util/map/createDefaultMapViewState";
import { StopVisualsMap } from "@app/util/map/markerStyles/types/StopVisual";

import { MULTI_PIN_RECORDS_PAGE_SIZE } from "../utils/constants";

import RouteAnnotation from "./types/RouteAnnotation";

export interface RouteRecordsListMultiPin {
  address?: string;
  entity?: MultiPin;
}

export interface RecordsListState {
  loading: boolean;
  mode: GeoPointSortType;
  multiPin?: RouteRecordsListMultiPin;
  query?: AreaSearchQuery;
  range: RangeModel;
  records: MapEntity[];
  search?: string;
  sort: SortModel;
  totalRecords: number;
}

export interface RouteMapState {
  annotation?: RouteAnnotation;
  categorizedExternalMapEntries: CategorizedMapEntries;
  categorizedMapEntries: CategorizedMapEntries;
  focusedStop?: EntityPin;
  goToLocationPopoverVisible: boolean;
  lasso: {
    allowAdd: boolean;
    containsClusters: boolean;
    loading: boolean;
    paths: GeoPath[];
  };
  pinHover?: string;
  pinsCount: number;
  pinsLoading: boolean;
  recordsList: RecordsListState;
  rulerPath: RulerPath;
  selected: {
    entities: MapEntity[];
    excluded: MapEntitiesSet;
    included: MapEntitiesSet;
    items: MapEntitiesSet;
  };
  selectedPin?: EntityPin;
  stopVisuals: StopVisualsMap;
  stopVisualsLoading: boolean;
  tool?: MapTool;
  viewport?: MapViewportState;
  viewState: MapViewState;
}

export const initialMapState: RouteMapState = {
  categorizedExternalMapEntries: { clusters: [], entities: [], multiPins: [] },
  categorizedMapEntries: { clusters: [], entities: [], multiPins: [] },
  goToLocationPopoverVisible: false,
  lasso: {
    allowAdd: true,
    containsClusters: false,
    loading: false,
    paths: [],
  },
  pinsCount: 0,
  pinsLoading: false,
  recordsList: {
    loading: false,
    mode: GeoPointSortType.CURRENT_USER_LOCATION,
    range: { endRow: MULTI_PIN_RECORDS_PAGE_SIZE, startRow: 0 },
    records: [],
    sort: [],
    totalRecords: 0,
  },
  rulerPath: [],
  selected: {
    entities: [],
    excluded: new Set<string>(),
    included: new Set<string>(),
    items: new Set<string>(),
  },
  stopVisuals: {},
  stopVisualsLoading: false,
  viewState: createDefaultMapViewState(),
};
